export default "__VITE_ASSET__D$NevrVS__"